function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.285 11.89l-2.578-2.594a1 1 0 00-1.416-.002L9 11.585l-5-5 2.294-2.294a1 1 0 00.001-1.414L3.715.293a1 1 0 00-1.415 0L.004 2.588C0 9.765 5.82 15.585 13 15.585l2.283-2.283a1 1 0 00.002-1.412z",
  fill: "#FFF"
});

var SvgPhone = function SvgPhone(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LjI4NSAxMS44OWwtMi41NzgtMi41OTRhMSAxIDAgMDAtMS40MTYtLjAwMkw5IDExLjU4NWwtNS01IDIuMjk0LTIuMjk0YTEgMSAwIDAwLjAwMS0xLjQxNEwzLjcxNS4yOTNhMSAxIDAgMDAtMS40MTUgMEwuMDA0IDIuNTg4QzAgOS43NjUgNS44MiAxNS41ODUgMTMgMTUuNTg1bDIuMjgzLTIuMjgzYTEgMSAwIDAwLjAwMi0xLjQxMnoiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvc3ZnPg==";
export { SvgPhone as ReactComponent };